/* Action Types */
export const UPDATE_PUBNUB_ONLINE_STATUS = 'updatePubnubOnlineStatus';
export const UPDATE_IDLE_STATUS = 'updateIdleStatus';
export const START_IDLE_TIMER = 'startIdleTimer';
export const CLEAR_IDLE_TIMER = 'clearIdleTimer';
/* Mutation Types */
export const SET_PUBNUB_ONLINE_STATUS = 'setPubnubOnlineStatus';
export const SET_IDLE_STATUS = 'setIdleStatus';
export const SET_IDLE_TIMER = 'setIdleTimer';
